import React, { ReactElement } from 'react';
import cn from 'classnames';
import { Checkbox } from '@odin-labs/components';

const classes = {
  consent: cn('odin-flex odin-items-start odin-text-sm odin-text-gray-700'),
};

export type SmsConsentCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * The SMS opt-in checkbox and its disclosure copy. The single source of truth
 * for that copy, shared by the self-onboarding account-creation step (where the
 * box is mandatory) and the policy re-capture gate (where it's optional), so
 * the disclosure stays identical everywhere SMS consent is captured.
 */
export function SmsConsentCheckbox({
  checked,
  onChange,
}: SmsConsentCheckboxProps): ReactElement {
  return (
    <label className={classes.consent}>
      <Checkbox
        checked={checked}
        onChange={(e): void => onChange(e.target.checked)}
      />
      <span>
        By checking this box, I agree to receive text messages from Odin
        regarding site safety and operations. Message and data rates may apply.
        Message frequency varies. Reply STOP to cancel, HELP for help.
      </span>
    </label>
  );
}
